import ReceptionLayout from './HostLayout';

export default ReceptionLayout;
